var _defs, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOpenFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "filter_ham",
    fill: "#050505",
    d: "M0 4.801h24v1.6H0zM3.2 11.199h17.6v1.6H3.2zM7.2 17.6h9.6v1.6H7.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "filter_x",
    fill: "#050505",
    d: "M6.131 5l12.445 12.445-1.131 1.131L5 6.131z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "filter_x",
    fill: "#050505",
    d: "M5 17.445L17.445 5l1.131 1.131L6.131 18.576z"
  })));
}

var MemoSvgOpenFilter = /*#__PURE__*/React.memo(SvgOpenFilter);
export default "data:image/svg+xml;base64,PHN2ZyAgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IGNsYXNzPSJmaWx0ZXJfaGFtIiB5PSI0LjgwMDc4IiB3aWR0aD0iMjQiIGhlaWdodD0iMS42IiBmaWxsPSIjMDUwNTA1Ii8+CjxyZWN0IGNsYXNzPSJmaWx0ZXJfaGFtIiB4PSIzLjE5OTk1IiB5PSIxMS4xOTkyIiB3aWR0aD0iMTcuNiIgaGVpZ2h0PSIxLjYiIGZpbGw9IiMwNTA1MDUiLz4KPHJlY3QgY2xhc3M9ImZpbHRlcl9oYW0iIHg9IjcuMTk5OTUiIHk9IjE3LjU5OTYiIHdpZHRoPSI5LjYiIGhlaWdodD0iMS42IiBmaWxsPSIjMDUwNTA1Ii8+CjxyZWN0IGNsYXNzPSJmaWx0ZXJfeCIgeD0iNi4xMzE0NyIgeT0iNSIgd2lkdGg9IjE3LjYiIGhlaWdodD0iMS42IiB0cmFuc2Zvcm09InJvdGF0ZSg0NSA2LjEzMTQ3IDUpIiBmaWxsPSIjMDUwNTA1Ii8+CjxyZWN0IGNsYXNzPSJmaWx0ZXJfeCIgeD0iNSIgeT0iMTcuNDQ1MyIgd2lkdGg9IjE3LjYiIGhlaWdodD0iMS42IiB0cmFuc2Zvcm09InJvdGF0ZSgtNDUgNSAxNy40NDUzKSIgZmlsbD0iIzA1MDUwNSIvPgo8L3N2Zz4K";
export { MemoSvgOpenFilter as ReactComponent };